import clsx from 'clsx'
import { ComponentProps } from 'react'

export function Section({ className, ...props }: ComponentProps<'section'>) {
  return <section className={clsx(className)} {...props} />
}
